import {
    inspectionDueDateOnlyCellTemplate,
    inspectionDueDateWithCalendarCellTemplate
} from "./CellTemplates";
import React from "react";

export const inspectionDueBodyTemplate = (rowData: any) => {
    if (!rowData.inspection?.isScheduled && rowData.scheduledDate) {
        return inspectionDueDateOnlyCellTemplate(
            new Date(rowData.scheduledDate),
            rowData.translationFunction
        );
    }

    if (
        !rowData.inspection ||
        (!rowData.inspection.isScheduled && !rowData.scheduledDate)
    ) {
        return <React.Fragment></React.Fragment>;
    }

    if (rowData.inspection.isScheduled) {
        return inspectionDueDateWithCalendarCellTemplate(rowData);
    }

    if (!rowData.inspection.inspectionDue) {
        return <React.Fragment></React.Fragment>;
    }

    return inspectionDueDateOnlyCellTemplate(
        new Date(rowData.inspection.inspectionDue),
        rowData.translationFunction
    );
};
